import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';

@Component({
    selector: 'payment-app',
    templateUrl: 'payment.component.html',
    providers: [LoginService]
})

export class PaymentComponent implements OnInit {
    displayview:boolean=false;
    collabos1: any = []
    tempProposalBids: any;
    userTypeName: string;
    displaycollabos: boolean = false;
    SelectedsstartDate = new Date();
    SelectedeendDate = new Date();
    myCollabos: any;
    presentprojects: any;
    proposalbidslist: any = [];
    bidslist: any = [];
    sample: any = [];

    //new
    CollaboName: string;
    actorNameJob: string;
    InvoiceNo: string;
    IsView: boolean = false;
    InvoiceDate: string;
    CompanyName: string;
    Address: string;
    City: string;
    Area: string;
    ZipCode: string;
    PhoneNo: string;
    viewInvoiceList: any;
    EmailAddress: string;

    collaboID: string;
    actorID: string;
    IsGenerate: boolean = false;
    actorsList: any;
    GenerateCollaboDetails: any;
    tempPraposaBids: any;
    collaboList = [];
    userType: string;
    userID: any;
    BidsList: any = [];
    invoiceList: any;
    tempInvoiceList: any;
    tempcollaboList: any;
    tempcol = [];
    tempColaboActorDetails: any;
    ColaboActorDetails: any;
    Actorid: string;
    ActorpercentageId: string;
    statusCollabos: any[];
    showproposal: boolean = false;
    showbids: boolean;
    tabtype: string;
    RowCollaboDetils: any;
    showPraposalDetails: any;
    IsDetails: boolean = false;
    detailsColaboList: any;
    tempCol: any;
    State: any;
    Country: any;
    allDetails: any;
    actors: any;
    totalamount: number;
    collabos: any = [];
    sum: any = 0;
    collabodetails: any;


    constructor(private loginService: LoginService) {
        this.userTypeName = localStorage.getItem('userType');
        this.userID = localStorage.getItem('USERID');

    }

    ngOnInit() {
        this.GetInvoices();
    }

    GetInvoices() {
        this.loginService.GetInvoices().subscribe(data => {
            data = JSON.parse(data['_body']);
            this.tempInvoiceList = JSON.parse(JSON.stringify(data));

        })
    }

    CompareDate() {

        if (this.SelectedsstartDate > this.SelectedeendDate) {
            this.displaycollabos = true;
            return;
        }
        else {
            this.displaycollabos = false;

            this.tempcol = [];


            this.loginService.GetPraposalBids().subscribe(data => {
                data = JSON.parse(data['_body']);
                this.tempPraposaBids = JSON.parse(JSON.stringify(data));

                this.BidsList = this.tempPraposaBids.filter(x => x.userid.toString() === this.userID.toString());

                this.loginService.GetCollabos(this.userTypeName).subscribe(data => {
                    data = JSON.parse(data['_body']);
                    this.tempcollaboList = JSON.parse(JSON.stringify(data));

                    this.loginService.GetCollaboActorDetails().subscribe(data1 => {

                        data1 = JSON.parse(data1["_body"]);
                        this.tempColaboActorDetails = JSON.parse(JSON.stringify(data1));

                        for (var i = 0; i < this.BidsList.length; i++) {
                            var list=this.tempcollaboList.filter(x => x.id === this.BidsList[i].collaboid)
                            if(list.length>0){
                            this.collaboList.push(list);
                            }
                        }
                        this.tempcol = [];

                        for (var i = 0; i < this.collaboList.length; i++) {
                            let tempColActors = this.tempColaboActorDetails.filter(x => x.CollaboId == this.collaboList[i][0].id);

                            let finalActorLit = [];
                            let filterBidActors = this.tempPraposaBids.filter(x => x.collaboid == this.collaboList[i][0].id && x.userid.toString() == this.userID.toString());
                            let actors = filterBidActors[0]["actorids"];



                            for (let i = 0; i < actors.length; i++) {

                                let filtercollaboActorDetails = tempColActors.filter(x => x.ActorId == actors[i])

                                if (filtercollaboActorDetails.length > 0) {

                                    finalActorLit.push(filtercollaboActorDetails[0]);
                                }

                            }

                            let filter = this.tempInvoiceList.filter(x => x.collaboid == this.collaboList[i][0].id && x.userid == this.userID);

                            if (filter.length > 0) {
                                this.invoiceList = filter;
                            }
                            else {
                                this.invoiceList = [];
                            }


                            this.tempcol.push({
                                GenerateInvoice: this.invoiceList,
                                bidActors: finalActorLit,
                                collaboAmout: (finalActorLit.length) * (parseInt(this.BidsList[0].amount) - parseInt(this.BidsList[0].servicecharge)),
                                region: (this.collaboList[i][0]).region,
                                title: (this.collaboList[i][0]).title,
                                paytype: (this.collaboList[i][0]).pay_type,
                                estimate: this.BidsList[0].hoursestimated,
                                postedon: (this.collaboList[i][0]).start_date,
                                status: (this.collaboList[i][0]).statusname,
                                id: (this.collaboList[i][0]).id,
                                statusid: (this.collaboList[i][0]).status,
                                description: this.BidsList[0].description,
                                bidvalue: this.BidsList[0].amount,
                                servicecharge: this.BidsList[0].servicecharge,
                                hours: this.BidsList[0].totalhours,
                                totalamount: (parseInt(this.BidsList[0].amount) - parseInt(this.BidsList[0].servicecharge)),
                                sub_category_id: this.collaboList[i].sub_category_id,
                                category1: this.collaboList[i][0].category1,
                                createddate: this.collaboList[i][0].createddate.split("T")[0],
                                name: this.collaboList[i][0].name,
                                expected_budget: this.collaboList[i][0].expected_budget,
                                estimated_time: this.collaboList[i][0].estimated_time,
                                pay_type: this.collaboList[i][0].pay_type,

                                start_date: this.collaboList[i][0].start_date,
                                end_date: this.collaboList[i][0].end_date,

                            })

                            if ((this.SelectedsstartDate.toString() >= this.tempcol[i].start_date.split("T")[0].toString()) && (this.SelectedeendDate.toString() <= this.tempcol[i].end_date.split("T")[0].toString())) {

                                this.collabos.push({
                                    title: this.tempcol[i].title,
                                    totalamount: this.tempcol[i].totalamount,
                                    pay_type: this.tempcol[i].pay_type,
                                    estimated_time: this.tempcol[i].estimated_time,
                                    start_date: this.tempcol[i].start_date
                                }
                                )
                                this.sum = this.sum + this.collabos[i].totalamount;
                                this.collabos1 = this.tempcol[i];

                            }


                        }

                    });
                });



            });
        }

    }

    viewdetails(d)
    {
        this.collabodetails=d;
        this.displayview=true;
    }
    backtoCollabos(){
        this.displayview=false;
      }
}

